<template>
    <div class="app-layout__content">
        <slot name="content"></slot>
    </div>
</template>

<script>

import {
  BCard
} from 'bootstrap-vue'

export default {
  components: {
      BCard,
  }
}
</script>

<style lang="scss">
    @import '@core/scss/base/bootstrap-extended/include'; // Bootstrap includes

    .app-layout--boxed .app-layout__content {
        background-color: white;
        padding: 1.5rem;
        border-radius: $card-border-radius;
    }

    .app-layout__content {
        flex-grow: 1;
        max-width: 100%;
    }
</style>
